import { msalInstance, tokenRequest} from "config/authConfigB2C"

export const getAccessTokenSilently = async () => {
    const account = msalInstance.getAllAccounts()[0];
    if (account) {
        const accessTokenResponse = await msalInstance.acquireTokenSilent({
            scopes: tokenRequest.scopes,
            forceRefresh: true,
            account: account
        }).catch( function (error) {
            // call loginRedirect in case of acquireTokenSilent failure
            // due to interaction required
            if (error.name === 'InteractionRequiredAuthError') {
                msalInstance.loginRedirect(tokenRequest);
            }
        });

        return accessTokenResponse.accessToken;
    }

    return null;
};